import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

/**
 * @constructor
 */
export class SystemStatusService {
  /** @private */
  _subject = new BehaviorSubject(SystemStatus.Initializing);
  status = this._subject.pipe(distinctUntilChanged());

  constructor() {
  }

  setSystemStatusToOnline() {
    this._subject.next(SystemStatus.Online);
  }

  setSystemStatusToOffline() {
    this._subject.next(SystemStatus.Offline);
  }
}

export const SystemStatus = {
  Initializing: 'initializing',
  Offline: 'offline',
  Online: 'online'
};

export const moduleName = 'systemStatus';
export default {
  moduleName,
};

angular
  .module('systemStatus', [])
  .service('SystemStatusService', SystemStatusService);
